import React from 'react';
import PropTypes from 'prop-types';
import BWLoader from '../BWLoader';
import { defaultActionIcon, defaultActionLabel, PortalIcon } from 'utils/baochauTheme';

const BWButton = ({
  loading = false,
  disabled = false,
  submit = false,
  reset = false,
  type = 'primary',
  outline = false,
  icon,
  content,
  onClick = () => {},
  style,
  table,
  styleIcon,
  iconOnly = false,
  showContent = false,
  ...props
}) => {
  const shouldRenderIconOnly = showContent ? false : iconOnly || Boolean(props?.globalAction);
  const typeButton = reset ? 'reset' : submit ? 'submit' : 'button';
  let className = `bw_btn bw_btn_${type}`;

  if (outline) {
    className = `bw_btn_outline bw_btn_outline_${type}`;
  } else if (table) {
    className = `bw_btn_table bw_${type}`;
  }

  const resolvedIcon = icon || (typeof content === 'string' ? defaultActionIcon(content) : '');
  const accessibleLabel =
    props?.['aria-label'] || props?.title || (typeof content === 'string' && content.trim()) || defaultActionLabel(resolvedIcon);
  const normalizedContent = typeof content === 'string' ? content.trim().toLowerCase() : '';
  const normalizedIcon = typeof resolvedIcon === 'string' ? resolvedIcon.toLowerCase() : '';
  const isCreateAction =
    normalizedContent.startsWith('thêm') ||
    normalizedIcon.includes('fi-rr-add') ||
    normalizedIcon.includes('fi-rr-plus');

  return (
    <React.Fragment>
      <button
        disabled={disabled}
        className={`${className} ${shouldRenderIconOnly ? 'bw_btn_icon_only' : ''} ${
          isCreateAction ? 'bw_btn_create_action' : ''
        } ${
          props?.className ? props?.className : ''
        }`}
        type={typeButton}
        title={accessibleLabel}
        aria-label={accessibleLabel}
        aria-busy={loading || undefined}
        onClick={onClick}
        style={style}>
        {loading && <BWLoader />}
        {Boolean(resolvedIcon) ? (
          <PortalIcon
            icon={resolvedIcon}
            className='bw_btn_icon'
            style={{ ...styleIcon, lineHeight: 0 }}
            aria-hidden='true'
          />
        ) : (
          ''
        )}
        {shouldRenderIconOnly && typeof content === 'string' ? <span className='bw_sr_only'>{content}</span> : content}
      </button>
    </React.Fragment>
  );
};

BWButton.propTypes = {
  className: PropTypes.string,
  type: PropTypes.oneOf(['button', 'primary', 'danger', 'success', 'warning', 'blue', 'red', 'green']),
  icon: PropTypes.string,
  content: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  loading: PropTypes.bool,
  outline: PropTypes.bool,
  iconOnly: PropTypes.bool,
  showContent: PropTypes.bool,
  globalAction: PropTypes.bool,
};

export default BWButton;
